import React, { Component } from "react";

import { scrollBy } from "../../actions/scroll";

import "./styles/components/Navigation.css";

class Navigation extends Component {
  handleScrollAndClose = section => {
    document.getElementById("nav-toggle").checked = false;
    if (section === "section-portfolio") {
      scrollBy(section, 170, 1000);
    } else {
      scrollBy(section, 100, 1000);
    }
  };

  render() {
    return (
      <div className="navigation">
        <input
          type="checkbox"
          className="navigation__checkbox"
          id="nav-toggle"
        />
        <label htmlFor="nav-toggle" className="navigation__button">
          <span className="navigation__icon">&nbsp;</span>
        </label>
        <div className="navigation__background">&nbsp;</div>
        <div className="navigation__nav">
          <ul className="navigation__list font-lato-light">
            <li
              onClick={() => this.handleScrollAndClose("section-about")}
              className="navigation__item"
            >
              About
            </li>
            <li
              onClick={() => this.handleScrollAndClose("section-features")}
              className="navigation__item"
            >
              Experience
            </li>
            <li
              onClick={() => this.handleScrollAndClose("section-portfolio")}
              className="navigation__item"
            >
              Portfolio
            </li>
            <li
              onClick={() => this.handleScrollAndClose("section-stories")}
              className="navigation__item"
            >
              Testimonials
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/layout/Navigation.js